import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-page">
      <div className="terms-content">
        <p>Coming Soon.</p>
        {/* <h1>Terms of Service</h1>
        <p>Last updated: October 21, 2025</p>

        <h2>1. Introduction</h2>
        <p>Welcome to Lift Coach AI! These Terms of Service ("Terms") govern your use of our website and mobile application (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms.</p>

        <h3>1.1. Acceptance of Terms</h3>
        <p>You must be at least 18 years old to use the Service. By creating an account, you represent that you are of legal age and agree to these Terms. If you do not agree, you may not use the Service.</p>

        <h2>2. Use of the Service</h2>
        <p>You are responsible for your use of the Service and for any content you provide, including compliance with applicable laws, rules, and regulations.</p>

        <h3>2.1. Prohibited Activities</h3>
        <p>You agree not to engage in any of the following prohibited activities:</p>
        <ul>
          <li>Copying, distributing, or disclosing any part of the Service in any medium.</li>
          <li>Using any automated system, including "robots," "spiders," "offline readers," etc., to access the Service.</li>
          <li>Transmitting spam, chain letters, or other unsolicited email.</li>
          <li>Attempting to interfere with, compromise the system integrity or security, or decipher any transmissions to or from the servers running the Service.</li>
        </ul>

        <h2>3. Placeholder Content</h2>
        <p>This is placeholder text. You should replace this with your own Terms of Service.</p>

        <h3>This is a sample h3 heading.</h3>
        <p>This is a sample paragraph. You can replace this with your own content. The styles for headings and paragraphs are already set up for you.</p> */}

      </div>
    </div>
  );
};

export default TermsOfService;
